import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Pill } from './StatusPill';
import { EM_DASH } from '../../utils/formatDate';

const LABELS = { field: 'Field', shop: 'Shop' };

/**
 * CategoryPill — Field (blue) / Shop (teal) pill. Shop is never orange.
 *
 * Props:
 *   category  'field' | 'shop', case-insensitive; unknown or empty renders "—"
 *   label     {node} overrides "Field" / "Shop"
 */
const CategoryPill = ({ category, label, ...props }) => {
  const { ft } = useTheme().palette;
  const key = typeof category === 'string' ? category.trim().toLowerCase() : '';

  if (!LABELS[key]) return <Box component="span">{EM_DASH}</Box>;

  return <Pill colors={ft.category[key]} label={label ?? LABELS[key]} {...props} />;
};

export default CategoryPill;
